import { Sparkles } from "lucide-react";
import type { RichModel } from "../../pages/models/ModelsPage.utils";

export function ModelIcon({ model }: { model: RichModel }) {
  return (
    <div className="grid size-11 shrink-0 place-items-center overflow-hidden rounded-xl bg-lumen-50 text-xl text-lumen-700 dark:bg-lumen-900/30 dark:text-lumen-300">
      {model.icon?.startsWith("/") || model.icon?.startsWith("http") ? (
        <img src={model.icon} alt="" className="size-full object-cover" />
      ) : (
        model.icon || <Sparkles size={20} />
      )}
    </div>
  );
}
